import { allocatable, hotDesk, meetingRoom, seatable, unallocatable } from './utils'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'

export const convertNeighborhoodSpacesToPoints = ({ ids, byId }) => {
  const sp = ids.reduce((result, id) => {
    const s = byId[id]
    return seatable(s.spaceType) ||
      meetingRoom(s.spaceType) ||
      hotDesk(s.usageType) ||
      allocatable(s.spaceType) ||
      unallocatable(s.spaceType)
      ? [...result, s]
      : result
  }, [])

  return sp.map((pro) => {
    const {
      x,
      y,
      w,
      code,
      spaceAssignment: { neighborhood, employee },
    } = pro
    const point = [x, y]
    point.w = w
    point.neighborhood = neighborhood
    point.code = code
    point.occupied = Boolean(employee)
    return point
  })
}

export const groupNeighborhoodCluster = (cluster) =>
  groupBy(cluster, ({ neighborhood }) => get(neighborhood, 'id'))
